import React, { useRef, useState, useEffect } from "react";

import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const VendorForm = (props) => {
  const frmRef = useRef({});

  const[loading,setLoading]=useState(false);

  const [backImage, setBackImage] = useState(
    "https://img.freepik.com/premium-vector/anonymous-user-circle-icon-vector-illustration-flat-style-with-long-shadow_520826-1931.jpg?w=1060"
  );
  const [profileUrl, setprofileUrl] = useState();

  const [attachmentUrl, setAttachmentUrl] = useState();

  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  ); // ;

  //console.log(integerPattern);

  const { sendRequest: postAddVendor } = useHttp();

  useEffect(() => {
    // //console.log(props.update);
    if (props.update) {
      frmRef.current.vendor_name.value = props.update.vendorName;
      frmRef.current.contact_person_name.value = props.update.contactPersonName;
      frmRef.current.status.value = props.update.status;
      frmRef.current.email_id.value = props.update.email;
      frmRef.current.id_proof.value = props.update.IdProof;
      frmRef.current.work_contact_number.value = props.update.contactWork;
      frmRef.current.whatsapp.value = props.update.whatsapp;
      frmRef.current.registered_address.value = props.update.registeredAddress;
      frmRef.current.vendor_city.value = props.update.vendorCity;
      frmRef.current.r_state.value = props.update.vendorState;
      frmRef.current.vendor_zipcode.value = props.update.vendorzipCode;
      frmRef.current.vendor_country.value = props.update.vendorCountry;
      frmRef.current.office_address.value = props.update.officeAddress;
      frmRef.current.office_city.value = props.update.officeCity;
      frmRef.current.office_state.value = props.update.officeState;
      frmRef.current.office_zipcode.value = props.update.officezipCode;
      frmRef.current.office_country.value = props.update.officeCountry;
      frmRef.current.goods_supplier.checked = props.update.is_goodsSupplier;
      frmRef.current.work_service_provider.checked =
        props.update.is_workServiceProvider;
      frmRef.current.machine_vehicle_equipement.checked =
        props.update.is_machinServices;
      frmRef.current.maintenance.checked = props.update.is_mainteinance;
      frmRef.current.labour_services.checked = props.update.is_labourServices;
      frmRef.current.account_number.value = props.update.bankAcNo;
      frmRef.current.account_holder_name.value = props.update.AccountHolderName;
      frmRef.current.ifsc_code.value = props.update.IFSC;
      frmRef.current.payment_terms_days.value = props.update.paymentTermsDays;
    }
    setAttachmentUrl(props.update.attachmentUrl);
    setBackImage(`${process.env.REACT_APP_FILE_URL}${props.update.profileUrl}`);
  }, [props.update]);

  const submitHandler = (e) => {
    e.preventDefault();
    const isServiceSelected =
      frmRef.current.goods_supplier.checked ||
      frmRef.current.work_service_provider.checked ||
      frmRef.current.machine_vehicle_equipement.checked ||
      frmRef.current.maintenance.checked ||
      frmRef.current.labour_services.checked;
    if (!isServiceSelected) {
      toast.error("Please select at least one service");
      return;
    }

    setLoading(true);

    const data = {
      vendorName: frmRef.current.vendor_name.value,
      contactPersonName: frmRef.current.contact_person_name.value,
      status: frmRef.current.status.value,
      email: frmRef.current.email_id.value,
      IdProof: frmRef.current.id_proof.value || " ",
      contactWork: frmRef.current.work_contact_number.value,
      whatsapp: frmRef.current.whatsapp.value,
      registeredAddress: frmRef.current.registered_address.value,
      vendorCity: frmRef.current.vendor_city.value,
      vendorState: frmRef.current.r_state.value,
      vendorzipCode: frmRef.current.vendor_zipcode.value,
      vendorCountry: frmRef.current.vendor_country.value,
      officeAddress: frmRef.current.office_address.value,
      officeCity: frmRef.current.office_city.value,
      officeState: frmRef.current.office_state.value,
      officezipCode: frmRef.current.office_zipcode.value,
      officeCountry: frmRef.current.office_country.value,
      is_goodsSupplier: frmRef.current.goods_supplier.checked,
      is_workServiceProvider: frmRef.current.work_service_provider.checked,
      is_machinServices: frmRef.current.machine_vehicle_equipement.checked,
      is_mainteinance: frmRef.current.maintenance.checked,
      is_labourServices: frmRef.current.labour_services.checked,
      bankAcNo: frmRef.current.account_number.value,
      AccountHolderName: frmRef.current.account_holder_name.value,
      IFSC: frmRef.current.ifsc_code.value,
      paymentTermsDays: frmRef.current.payment_terms_days.value,
      profileUrl: profileUrl ||"",
      attachmentUrl: attachmentUrl ||"",
      orgId: localStorage.getItem("orgId"),
      createdBy: localStorage.getItem("id"),
      serviceId:props.sId,
    };
    if (props.update) {
      data["vendorId"] = props.update.vendorId;
    }
    console.log("Data", data);
    postAddVendor(
      {
        url: "/api/addVendor/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(`Vendor ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  function setAddr() {
    frmRef.current.office_address.value =
      frmRef.current.registered_address.value;
    frmRef.current.office_city.value = frmRef.current.vendor_city.value;
    frmRef.current.office_state.value = frmRef.current.r_state.value;
    frmRef.current.office_zipcode.value = frmRef.current.vendor_zipcode.value;
    frmRef.current.office_country.value = frmRef.current.vendor_country.value;
  }

  function clearAddr() {
    frmRef.current.office_address.value = "";
    frmRef.current.office_city.value = "";
    frmRef.current.office_state.value = "";
    frmRef.current.office_zipcode.value = "";
    frmRef.current.office_country.value = "";
  }

  const onChange = (e) => {
    //console.log(`checked = ${e.target.checked}`);
    const flag = e.target.checked || false;
    if (flag == true) {
      setAddr();
    } else {
      clearAddr();
    }
  };

    const attachmentFolder=localStorage.getItem("attachmentFolder");

  const uploadProImage = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);

    // //console.log("picData", picData);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/vendorProfiles/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setBackImage(`${process.env.REACT_APP_FILE_URL}${data.url}`);
        setprofileUrl(data.url);
      })
      .catch((err) => console.error(err));
  };

  const AttachmentUpload = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/vendorAttachment/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setAttachmentUrl(data.url);
      })
      .catch((err) => console.error(err));
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">

              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Vendor/Supplier Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 text-center">
                      <div className="form-group mt-1">
                        <img
                          src={`${backImage}`}
                          className="user-image img-circle"
                          width="140"
                          height="140"
                          alt="User Image"
                        />

                        <div className="input-group">
                          <div className="custom-file">
                            <label style={{ cursor: "pointer" }}>
                              <input
                                type="file"
                                className="custom-file-input"
                                id="file"
                              accept="image/*"
                                onChange={uploadProImage}
                              />
                              Upload
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor={"vendor_name"}> {"Vendor Name"}</label>
                        <input
                          type={"text"}
                          id={"vendor_name"}
                          required
                          ref={(el) => (frmRef.current["vendor_name"] = el)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"payment_terms_days"}>
                          {"Payment Terms in Days"}
                        </label>
                        <input
                          type={"text"}
                          id={"payment_terms_days"}
                          maxLength={3}
                          pattern={integerPattern}
                          required
                          ref={(el) =>
                            (frmRef.current["payment_terms_days"] = el)
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"work_contact_number"}>
                          {"Contact Number"}
                        </label>
                        <input
                          type={"text"}
                          id={"work_contact_number"}
                          minLength={10}
                          pattern={integerPattern}
                          required
                          ref={(el) =>
                            (frmRef.current["work_contact_number"] = el)
                          }
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor={"contact_person_name"}>
                          {"Contact Person Name"}
                        </label>
                        <input
                          type={"text"}
                          id={"contact_person_name"}
                          required
                          ref={(el) =>
                            (frmRef.current["contact_person_name"] = el)
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor={"email_id"}> {"Email Id"}</label>
                        <input
                          type={"email"}
                          id={"email_id"}
                          required
                          ref={(el) => (frmRef.current["email_id"] = el)}
                          className="form-control"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor={"whatsapp"}>{"Whatsapp Number"}</label>
                        <input
                          type={"tel"}
                          id={"whatsapp"}
                          pattern={integerPattern}
                          placeholder=""
                          minLength={10}
                          required
                          ref={(el) => (frmRef.current["whatsapp"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor={"status"}> {"Status"}</label>
                        <select
                          id="status"
                          className="form-control"
                          ref={(el) => (frmRef.current["status"] = el)}
                        >
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </div>
                      <div className="row">
                        <div className="col-md-8">
                          <label htmlFor={"id_proof"}>{"ID Proof"}</label>
                          <input
                            type={"text"}
                            id={"id_proof"}
                            required
                            ref={(el) => (frmRef.current["id_proof"] = el)}
                            className="form-control"
                          />
                        </div>
                        <div className="col-md-4">
                          <br />
                          <br />
                          <label className="custom-attach-upload">
                            <input
                              onChange={AttachmentUpload}
                              type="file"
                             accept="image/*"
                              style={{ display: "none", cursor: "pointer" }}
                            //  required={props.update ? false : true}
                              ref={(el) => (frmRef.current["attachment"] = el)}
                            />
                            <i className="fas fa-solid fa-upload"></i>
                            {attachmentUrl && (
                              <span
                                onClick={() =>
                                  window.open(
                                    `${process.env.REACT_APP_FILE_URL}${attachmentUrl}`,
                                    "_blank"
                                  )
                                }
                              ></span>
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"account_number"}>
                        {" "}
                        {"Bank Account Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"account_number"}
                        ref={(el) => (frmRef.current["account_number"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"registered_address"}>
                        {"Registered Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"registered_address"}
                        required
                        ref={(el) =>
                          (frmRef.current["registered_address"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendor_city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"vendor_city"}
                        required
                        ref={(el) => (frmRef.current["vendor_city"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"r_state"}>
                        {" "}
                        {"State/Province/Region"}
                      </label>
                      <input
                        type={"text"}
                        id={"r_state"}
                        required
                        ref={(el) => (frmRef.current["r_state"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"account_holder_name"}>
                        {"Account Holder Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"account_holder_name"}
                        ref={(el) =>
                          (frmRef.current["account_holder_name"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendor_zipcode"}>{"Zip Code"}</label>
                      <input
                        type={"text"}
                        id={"vendor_zipcode"}
                        required
                        ref={(el) => (frmRef.current["vendor_zipcode"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vendor_country"}> {"Country"}</label>
                      <input
                        type={"text"}
                        id={"vendor_country"}
                        required
                        ref={(el) => (frmRef.current["vendor_country"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3 mb-2">
                      <label htmlFor={"ifsc_code"}>{"IFSC Code"}</label>
                      <input
                        type={"text"}
                        id={"ifsc_code"}
                        ref={(el) => (frmRef.current["ifsc_code"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-8 mb-2">
                      <div className="form-check my-4">
                        <input
                          type={"checkbox"}
                          id={"same_address"}
                          ref={(el) => (frmRef.current["same_address"] = el)}
                          className="form-check-input"
                          onChange={onChange}
                        />
                        <label
                          htmlFor={"same_address"}
                          className="form-check-label"
                        >
                          {"Shipping Address same as  Billing Address"}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label className="text-left">Associated Services</label>

                      <div className="input-group mx-3">
                        <input
                          type={"checkbox"}
                          id={"goods_supplier"}
                          ref={(el) => (frmRef.current["goods_supplier"] = el)}
                          className="form-check-input"
                        />
                        <p className="card-title" htmlFor={"goods_supplier"}>
                          {" "}
                          {"Goods Supplier"}
                        </p>
                      </div>

                      <div className="input-group mx-3">
                        <input
                          type={"checkbox"}
                          id={"work_service_provider"}
                          ref={(el) =>
                            (frmRef.current["work_service_provider"] = el)
                          }
                          className="form-check-input"
                        />
                        <p
                          htmlFor={"work_service_provider"}
                          className="card-title"
                        >
                          {"Work Service Provider"}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"office_address"}>
                        {" "}
                        {"Office Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"office_address"}
                        required
                        ref={(el) => (frmRef.current["office_address"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"office_city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"office_city"}
                        required
                        ref={(el) => (frmRef.current["office_city"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"office_state"}>
                        {" "}
                        {"State/Province/Region"}
                      </label>
                      <input
                        type={"text"}
                        id={"office_state"}
                        required
                        ref={(el) => (frmRef.current["office_state"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <div className="input-group mx-3">
                        <input
                          type={"checkbox"}
                          id={"machine_vehicle_equipement"}
                          ref={(el) =>
                            (frmRef.current["machine_vehicle_equipement"] = el)
                          }
                          className="form-check-input"
                        />
                        <p
                          htmlFor={"machine_vehicle_equipement"}
                          className="card-title"
                        >
                          {"Machine/Vehicle"}
                        </p>
                      </div>
                      <div className="input-group mx-3">
                        <input
                          type={"checkbox"}
                          id={"maintenance"}
                          ref={(el) => (frmRef.current["maintenance"] = el)}
                          className="form-check-input"
                        />
                        <p htmlFor={"maintenance"} className="card-title">
                          {"Maintenance"}
                        </p>
                      </div>

                      <div className="input-group mx-3">
                        <input
                          type={"checkbox"}
                          id={"labour_services"}
                          ref={(el) => (frmRef.current["labour_services"] = el)}
                          className="form-check-input"
                        />
                        <p htmlFor={"labour_services"}>{"Labour Services"}</p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"office_country"}> {"Country"}</label>
                      <input
                        type={"text"}
                        id={"office_country"}
                        required
                        ref={(el) => (frmRef.current["office_country"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"office_zipcode"}>
                        {"Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"office_zipcode"}
                        required
                        ref={(el) => (frmRef.current["office_zipcode"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2"></div>

                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default VendorForm;
